import { gql } from '@apollo/client';

/**
 * ТЗ 0093 — runtime-настройки: общие наборы полей.
 *
 * Ключ (`RuntimeSettingType`) выбирается ОДНИМ фрагментом и в списке, и в
 * ответах `setRuntimeSetting` / `clearRuntimeSetting`: запись кэша
 * `RuntimeSettingType:<key>` (keyFields — `key`, `core/cache/cache.ts`) у них
 * общая, и ответ мутации обновляет строку на экране без перечитывания
 * списка.
 *
 * `value` / `envValue` / `dbValue` — JSONString: на выходе JSON-текст
 * (`"false"`, `"14"`, `"\"claude-haiku-4-5\""`), разбирает модель.
 */
export const SCHEDULED_RUN_FIELDS = gql`
  fragment ScheduledRunFields on ScheduledRunType {
    beatKey
    at
    source
    status
    error
    triggerSource
  }
`;

export const RUNTIME_SETTING_FIELDS = gql`
  fragment RuntimeSettingFields on RuntimeSettingType {
    key
    section
    type
    mode
    danger
    labelRu
    labelPl
    helpRu
    helpPl
    value
    envValue
    dbValue
    hasDbValue
    source
    serverForbids
    standBlocks
    readOnly
    choices
    updatedAt
    updatedByName
    beatKeys
    lastRun {
      ...ScheduledRunFields
    }
  }
`;
